import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export const deleteFirmware = async (namespace: string, firmwareId: string) => {
  const url = otaUpdatesUrlEnvVar();
  const headers = {
    ...buildAxiosAuthenticationHeaders(),
  };

  try {
    const response = await axios.delete(
      `${url}/api/v1/ns/${namespace}/firmware`,
      {
        headers,
        params: {
          firmware_id: firmwareId,
        },
      },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        "Failed to delete firmware. Please try again later.";

      throw new Error(message);
    } else {
      throw new Error("An unexpected error occurred while deleting firmware.");
    }
  }
};
